import { workflowComponent } from '@banking/ui/services/bank-accounts';
import { hbs } from 'ember-cli-htmlbars';
import { closeCheckingUpsellModalAction } from '@banking/ui/workflows/bank-accounts/checking-upsell';
const template = hbs`
<Banking::Checking::BankLinking::CheckingUpsellModal
  @isCheckingUpsellModalOpen={{this.isModalOpen}}
  @dismissModal={{this.dismissCheckingUpsellModal}}
  @itFee={{this.itFee}}
  @isLoading={{this.isLoading}}
  @unitToken={{this.unitToken}}
  @merchantToken={{this.merchantToken}} />
`;
export const mapStateToProps = state => ({
  isModalOpen: state.checkingUpsellModal.isModalOpen,
  itFee: state.checkingUpsellModal.itFee,
  isLoading: state.checkingUpsellModal.isLoading,
  merchantToken: state.checkingUpsellModal.merchantToken,
  unitToken: state.checkingUpsellModal.unitToken
});
const mapActionsToProps = () => ({
  dismissCheckingUpsellModal: closeCheckingUpsellModalAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);